'use client'

import { ArrowLeftIcon } from '@modules/common/icons'

export default function BackToTopButton() {
  return (
    <button
      className="fixed bottom-20 right-10 z-50 rotate-90 rounded-full bg-green p-2 shadow-xl"
      onClick={() => {
        window.scrollTo(0, 0)
      }}
    >
      <ArrowLeftIcon color="#fff" width={25} height={25} />
    </button>
  )
}
